import Entity from "../Entities/Entity";
import BaseService from "./BaseService";

export default abstract class CachedBaseService<TEntity extends Entity> extends BaseService<TEntity> {
    private cachedItems: TEntity[] = null;

    public async getItems(filter?: string): Promise<TEntity[]> {
        if (!this.cachedItems) {
            // Only an answer that arrived is kept: caching a failed request would leave the list empty
            // for the rest of the session.
            this.cachedItems = await this.tryGetItems(filter);
        }
        return this.cachedItems ?? [];
    }
}
